import {zodResolver} from '@hookform/resolvers/zod'
import {
    forgotPasswordField,
    forgotPasswordFieldValidation,
} from 'constants/FormField/forgotPasswordField'
import useResponsive from 'logic/useResponsive'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {toast} from 'sonner'
import {useForgotPasswordMutation} from 'store/Store'

const useForgotPassword = ({i18nCategory}) => {
    const {mediumScreen} = useResponsive()
    const methods = useForm({
        resolver: zodResolver(forgotPasswordFieldValidation),
    })
    const navigate = useNavigate()

    const {handleSubmit} = methods
    const {t} = useTranslation()

    const [doSubmit, {error}] = useForgotPasswordMutation()
    const onSubmit = (data) => {
        toast.promise(
            doSubmit(data)
                .unwrap()
                .then(() => {
                    navigate('/login')
                })
                .catch((error) => {
                    console.log('toast error', error)
                    throw error
                }),
            {
                loading: t('loading'),
                success: () => t(`${i18nCategory}.success`),
                error: () => t(`${i18nCategory}.error`),
            }
        )
    }
    return {
        handleSubmit,
        onSubmit,
        error,
        mediumScreen,
        methods,
        t,
        formField: forgotPasswordField,
    }
}

export default useForgotPassword
